module.exports = __webpack_public_path__ + "img/icon_kontak_info.7ffb1cc6.svg";